import { isBrowser } from './Window.js';

const _docFontSize = isBrowser() && getComputedStyle(document.documentElement).fontSize || 16;
const BASE_FONT_SIZE = parseInt(_docFontSize, 10);
const screens = {
  sm: '26em',
  // 416px
  md: '47em',
  // 752px
  lg: '64.0625em',
  // 1024px
  xl: '80em' // default breakpoint 1280px
};
const breakpoints = {
  screenSmallest: 0,
  screenSmall: parseFloat(screens.sm, 10) * BASE_FONT_SIZE,
  screenMedium: parseFloat(screens.md, 10) * BASE_FONT_SIZE,
  screenLarge: parseFloat(screens.lg, 10) * BASE_FONT_SIZE,
  screenBase: parseFloat(screens.xl, 10) * BASE_FONT_SIZE
};
const bp = breakpoints,
  mediaQuery = {
    min: {},
    max: {}
  };
for (const key in bp) {
  if (bp.hasOwnProperty(key)) {
    mediaQuery.min[key] = `screen and (min-width: ${bp[key]}px)`;
    mediaQuery.max[key] = `screen and (max-width: ${bp[key]}px)`;
  }
}
const getBreakPointAlias = () => {
  /* Conditional CSS http://adactio.com/journal/5429/ */
  if (window.getComputedStyle) {
    return window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/"/g, '').trim();
  }
  // default to large if getComputedStyle not available
  return 'large';
};
const getCurrentBreakPoint = () => {
  let alias = getBreakPointAlias();
  // uppercase first letter
  alias = alias.charAt(0).toUpperCase() + alias.slice(1);
  return breakpoints['screen' + alias];
};
const MediaQueries = {
  ...mediaQuery,
  getBreakPointAlias,
  getCurrentBreakPoint
};

export { breakpoints, MediaQueries as default };
//# sourceMappingURL=MediaQueries.js.map
